import axios from "axios";
import { ResponseAPIModel } from "../../../../setup/models/ResponseAPIModel";
import { LinkPaymentModel, ILinkPaymentSearchModel, LinkPaymentSearchResponseModel } from "../models";

const API_URL = process.env.REACT_APP_API_URL || '/api'


export const LINKPAYMENT_SEARCH_URL = `${API_URL}/payment/link-payment/search`;
export const LINKPAYMENT_GET_URL = `${API_URL}/payment/link-payment`;
export const LINKPAYMENT_ADD_URL = `${API_URL}/payment/link-payment/add`;
export const LINKPAYMENT_SUSPEND_URL = `${API_URL}/payment/link-payment/suspend`;

export const linkPaymentSearch = (findModel: ILinkPaymentSearchModel) => {
    return axios.post<ResponseAPIModel<LinkPaymentSearchResponseModel>>(LINKPAYMENT_SEARCH_URL, findModel);
}

export function linkPaymentGetDetails(token: string) {
    return axios.get<ResponseAPIModel<LinkPaymentModel>>(`${LINKPAYMENT_GET_URL}/${token}`);
}

export const linkPaymentAdd = (paymentModel: LinkPaymentModel) => {
    return axios.post<ResponseAPIModel<string>>(LINKPAYMENT_ADD_URL, paymentModel);
}

export const linkPaymentSuspend = (token: string) => {
    return axios.get<ResponseAPIModel<boolean>>(`${LINKPAYMENT_SUSPEND_URL}/${token}`);
}